export const keydownFormatTime = (event) => {
  const {
    key,
    code,
    target: { value }
  } = event

  if (code.indexOf('Digit') === -1 || value.length > 3 || key === 'h')
    return

  if (
    // validando o primeiro digito
    (value === '' && eval(key) > 2) ||
    // validando o segundo digito
    (value.length === 1 && eval(value) === 2 && eval(key) > 3) ||
    // validando o terceiro digito
    (value.length === 2 && eval(key) > 5) ||
    (value.length === 3 && eval(key) > 5)
  ) {
    event.preventDefault()
  }
}

//it needed to use the attribute pattern in the input tag
export const keydownAllowOnlyPattern = (event) => {
  const {
    key,
    target: { pattern }
  } = event

  const regex = new RegExp(pattern)
  if (!regex.test(key)) {
    event.preventDefault()
  } else {
    return
  }
}

export const lockIfValueIsNull = (event) => {
  const { target } = event

  if (target.value.length === 0) {
    target.focus()
  }
}



// WEBPACK FOOTER //
// ./src/utils/events.js